import type { FileIconProps } from './FileIcon';

function FileVideoIcon({ extension, color, size = 28, ...props }: FileIconProps) {
  return (
    <svg
      width={size}
      height={size * 1.25}
      viewBox='0 0 28 36'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <g clipPath='url(#clip0_407_6016)'>
        <path
          d='M4 35.5H24C26.2091 35.5 28 33.7091 28 31.5V10.5V4.5C28 2.29086 26.2091 0.5 24 0.5H18H4C1.79086 0.5 0 2.29086 0 4.5V31.5C0 33.7091 1.79086 35.5 4 35.5Z'
          fill={color}
        />
        <path
          opacity='0.4'
          fillRule='evenodd'
          clipRule='evenodd'
          d='M-6.10502 11.9631C-6.10502 10.7979 -5.16047 9.85335 -3.9953 9.85335H-1.06755V14.8909H-6.10502V11.9631ZM-6.10502 16.2442H-1.06755V21.2817H-6.10502V16.2442ZM-7.45837 11.9631V15.5675V21.9583V28.3491V31.9536C-7.45837 33.8662 -5.9079 35.4166 -3.9953 35.4166H-0.390876H12.3908H15.9952C17.9078 35.4166 19.4583 33.8662 19.4583 31.9536V28.3491V21.9583V15.5675V11.9631C19.4583 10.0505 17.9078 8.5 15.9952 8.5H12.3908H-0.390876H-3.9953C-5.9079 8.5 -7.45837 10.0505 -7.45837 11.9631ZM18.1049 14.8909V11.9631C18.1049 10.7979 17.1604 9.85335 15.9952 9.85335H13.0674V14.8909H18.1049ZM13.0674 16.2442H18.1049V21.2817H13.0674V16.2442ZM11.7141 15.5675V9.85335H0.2858L0.2858 15.5675L0.2858 21.2817H11.7141V15.5675ZM18.1049 22.635V27.6725H13.0674V22.635H18.1049ZM18.1049 29.0258H13.0674V34.0633H15.9952C17.1604 34.0633 18.1049 33.1187 18.1049 31.9536V29.0258ZM11.7141 22.635V28.3491V34.0633H0.2858L0.2858 28.3491L0.2858 22.635H11.7141ZM-6.10502 29.0258V31.9536C-6.10502 33.1187 -5.16047 34.0633 -3.9953 34.0633H-1.06755V29.0258H-6.10502ZM-1.06755 27.6725H-6.10502V22.635H-1.06755V27.6725Z'
          fill='url(#paint0_linear_407_6016)'
        />
        <text fill='#fff' x='50%' y='90%' textAnchor='middle' fontSize={9} fontWeight='bold'>
          {extension?.toUpperCase()}
        </text>
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_407_6016'
          x1='5.99995'
          y1='8.5'
          x2='5.99995'
          y2='35.4166'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='white' />
          <stop offset='1' stopColor='white' stopOpacity='0' />
        </linearGradient>
        <clipPath id='clip0_407_6016'>
          <path
            d='M0 4.5C0 2.29086 1.79086 0.5 4 0.5H24C26.2091 0.5 28 2.29086 28 4.5V31.5C28 33.7091 26.2091 35.5 24 35.5H4C1.79086 35.5 0 33.7091 0 31.5V4.5Z'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default FileVideoIcon;
